import { render } from "./Planet.vue?vue&type=template&id=3c6fcffb&scoped=true"
import script from "./Planet.vue?vue&type=script&lang=js"
export * from "./Planet.vue?vue&type=script&lang=js"

import "./Planet.vue?vue&type=style&index=0&id=3c6fcffb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6fcffb"]])

export default __exports__